import { useCallback, useState } from 'react';

const storageKey = (userId: string) => `qo.notifications.seen.${userId}`;

const read = (userId: string): string[] => {
    try {
        const parsed: unknown = JSON.parse(localStorage.getItem(storageKey(userId)) ?? '[]');
        return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : [];
    } catch {
        return [];
    }
};

/** An event is unread again when its `since` changes, so the key carries both. */
export const seenKey = (n: { id: string; since: string | null }): string => `${n.id}@${n.since ?? ''}`;

/** Keys of events already seen by this user, remembered in localStorage. Marking replaces the set, so resolved events drop out. */
export const useSeen = (userId: string): { seen: ReadonlySet<string>; markSeen: (keys: string[]) => void } => {
    const [seen, setSeen] = useState<ReadonlySet<string>>(() => new Set(read(userId)));
    const markSeen = useCallback(
        (keys: string[]) => {
            localStorage.setItem(storageKey(userId), JSON.stringify(keys));
            setSeen(new Set(keys));
        },
        [userId]
    );
    return { seen, markSeen };
};
